import { Injectable } from '@angular/core';
import { WorkspaceAssetEventService } from '../../../../socket/workspace/asset/workspace-asset-event.service';
import { Subject } from 'rxjs';
import {
    IWorkspaceAssetSocketData,
    IGeneratedVideoSocketData,
} from '../../../../../models/socket-events/workspace/asset/workspace-asset-event';

@Injectable()
export class WorkspaceAssetEventListenerService {
    private _onAssetUpdatedSubject = new Subject<IWorkspaceAssetSocketData>();
    public onAssetUpdated$ = this._onAssetUpdatedSubject.asObservable();

    private _onAssetCreatedSubject = new Subject<IWorkspaceAssetSocketData>();
    public onAssetCreated$ = this._onAssetCreatedSubject.asObservable();

    private _onAssetDeletedSubject = new Subject<IWorkspaceAssetSocketData>();
    public onAssetDeleted$ = this._onAssetDeletedSubject.asObservable();

    private _onGeneratedVideoSubject = new Subject<IGeneratedVideoSocketData>();
    public onGeneratedVideo$ = this._onGeneratedVideoSubject.asObservable();
    constructor(private workspaceAssetEventService: WorkspaceAssetEventService) {
        this.listenToAssetUpdated();
        this.listenToAssetCreated();
        this.listenToAssetDeleted();
        this.listenToGeneratedVideo();
    }

    private listenToAssetUpdated() {
        this.workspaceAssetEventService.onAssetUpdate().subscribe({
            next: (data) => {
                this._onAssetUpdatedSubject.next(data);
            },
        });
    }
    private listenToAssetCreated() {
        this.workspaceAssetEventService.onAssetCreated().subscribe({
            next: (data) => {
                this._onAssetCreatedSubject.next(data);
            },
        });
    }

    private listenToAssetDeleted() {
        this.workspaceAssetEventService.onAssetDeleted().subscribe({
            next: (data) => {
                this._onAssetDeletedSubject.next(data);
            },
        });
    }

    private listenToGeneratedVideo() {
        this.workspaceAssetEventService.onGeneratedVideo().subscribe({
            next: (data) => {
                this._onGeneratedVideoSubject.next(data);
            },
        });
    }
}
